import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface NormalDatePickerProps {
  value: Date | null;
  onChange: (date: Date | null) => void;
  disabled?: boolean;
  dateFormat?: string;
  maxDate?: Date;
}

const NormalDatePicker: React.FC<NormalDatePickerProps> = ({
  value,
  onChange,
  disabled = false,
  dateFormat = "MM/dd/yyyy",
  maxDate,
}) => {
  return (
    <div className="position-relative">
      <DatePicker
        selected={value}
        onChange={onChange}
        dateFormat={dateFormat}
        disabled={disabled}
        placeholderText="Select date"
        className="form-control pe-5" // space for icon
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        peekNextMonth
        popperPlacement="bottom-start"
        portalId="root-portal"
        maxDate={maxDate}
      />

      {/* Calendar Icon */}
      <span
        className="material-icons material-symbols-outlined date_ic"
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: disabled ? "not-allowed" : "pointer",
          color: "#6c757d",
          pointerEvents: "none",
        }}
      >
        calendar_month
      </span>
    </div>
  );
};

export default NormalDatePicker;
